// src/project/data/fetches/commissionsStats.js
// V3 : Les stats de commission sont agrégées via le solde wallet.
import { buildUrlWithAuth, RIDER_ENDPOINTS, getRiderId } from '../config/apiConfig'

export default {
  url() {
    const userId = getRiderId()
    return buildUrlWithAuth(RIDER_ENDPOINTS.WITHDRAWAL_STATS(userId))
  },
  parse(raw = {}) {
    if (raw?.statusCode !== 200) {
      return { statusCode: raw?.statusCode || 500, data: { total: 0 } }
    }
    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: raw?.data?.amount || 0,
      },
    }
  },
}
